import './contenuto-accordion.scss';
/**
 * version    1.0
 * class      <type> (ContenutoAccordion)
 * classdesc  Component that manage the contenuto-accordion section
 */
export class ContenutoAccordion {
  constructor() {
    this.roots = document.querySelectorAll('.section-contenuto-accordion');
    if (this.roots.length === 0) return;

    this.init();
  }

  init() {
    const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

    this.roots.forEach((root) => {
      const items = root.querySelectorAll('.accordion-item');

      items.forEach((item) => {
        const cards = item.querySelectorAll('.cdp-card');
        const title = item.querySelector('.contenuto-accordion__title');
        const collapse = item.querySelector('.accordion-collapse');

        if (!title || !collapse) return;

        if (isDesktop()) {
          if (cards.length === 0 || (cards.length > 0 && cards.length < 4)) {
            if (!root.classList.contains('section-contenuto-rating') && !root.classList.contains('accordion-always-on')) {
              this.disableAccordionForItem(item);
              return;
            }
          }
        }

        title.setAttribute('tabindex', '0');
        title.setAttribute('role', 'button');
        this.updateIconState(title);

        title.addEventListener('click', () => {
          window.setTimeout(() => this.updateIconState(title), 0);
        });

        // Gestione tastiera (Enter e Space)
        title.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            title.click();
          }
        });
      });
    });
  }

  disableAccordionForItem(item) {
    const title = item.querySelector('.contenuto-accordion__title');
    const collapse = item.querySelector('.accordion-collapse');

    if (!title || !collapse) return;

    const icon = title.querySelector('.contenuto-accordion__icon');
    if (icon) {
      icon.style.display = 'none';
    }

    title.removeAttribute('data-bs-toggle');
    title.removeAttribute('data-bs-target');

    const collapseId = collapse.getAttribute('id');
    if (collapseId && title.getAttribute('aria-controls') === collapseId) {
      title.removeAttribute('aria-controls');
    }

    title.removeAttribute('aria-expanded');
    title.classList.add('contenuto-accordion__title--disabled');
    title.removeAttribute('tabindex');
    title.removeAttribute('role');

    collapse.classList.add('show');
  }

  updateIconState(title) {
    const useEl = title.querySelector('.contenuto-accordion__icon use');
    if (!useEl) return;

    const isExpanded = title.getAttribute('aria-expanded') === 'true';
    useEl.setAttribute('xlink:href', isExpanded ? '#sprite-close' : '#sprite-plus');

    if (isExpanded) {
      title.classList.add('contenuto-accordion__title--open');
    } else {
      title.classList.remove('contenuto-accordion__title--open');
    }
  }
}
